import { FooterProps } from "@/components/Inputs/RangePicker/components/Footer/FooterProps.ts";
import { useScreenSize } from "@/helpers/hooks/useScreenSize.tsx";
import { locales } from "@/helpers/locales.ts";
import { add, differenceInDays } from "date-fns";
import format from "date-fns/format";
import i18n from "i18next";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaMoon } from "react-icons/fa";

export const Footer = (props: FooterProps) => {
  const { startDate, endDate, hoveredDate, onChange, setHideDatePicker } = props;
  const locale = locales[i18n.language];
  const { t } = useTranslation();
  const screenSize = useScreenSize();

  const nightCount = useMemo(() => {
    if (screenSize.width < 768 && startDate && endDate) {
      return `${format(new Date(startDate), "dd.MM", { locale })} - ${format(new Date(endDate), "dd.MM", {
        locale,
      })} `;
    }
    if (startDate && !endDate && hoveredDate) {
      const difference = differenceInDays(new Date(hoveredDate), new Date(startDate));
      return `${difference < 0 ? -difference : difference} ${difference === 1 ? t("night") : t("nights")}`;
    } else if (startDate && endDate) {
      const difference = differenceInDays(new Date(endDate), new Date(startDate));
      return `${difference} ${difference === 1 ? t("night") : t("nights")}`;
    }
    return `0 ${t("nights")}`;
  }, [startDate, endDate, screenSize.width, locale, t, hoveredDate]);

  const handleOnConfirm = () => {
    if (!startDate || !endDate) {
      onChange?.([new Date(), add(new Date(), { days: 1 })]);
    }
    setHideDatePicker(true);
  };

  return (
    <div className="daypicker-popup__footer">
      <div className="daypicker-popup__nights">
        <FaMoon />
        {nightCount}
      </div>
      <div>
        <button
          className="daypicker-popup__deselectButton"
          disabled={startDate === null}
          onClick={() => onChange?.([null, null])}
        >
          {t("deselect")}
        </button>
        <button className="daypicker-popup__confirmButton" onClick={handleOnConfirm}>
          {t("confirm")}
        </button>
      </div>
    </div>
  );
};
